module.exports = __webpack_public_path__ + "static/media/imagePlaceholder.bb5b172b.svg";